import './Placeholder.css';

export default function AskMeAnything() {
  return (
    <div className="placeholder-page">
      <div className="placeholder-content">
        <div className="placeholder-icon">💬</div>
        <h1>Ask Me Anything</h1>
        <p>AI-powered Q&amp;A interface coming soon</p>
        <p className="placeholder-description">
          Ask questions about your policy documents and get intelligent answers powered by AI
        </p>
      </div>
    </div>
  );
}
